export var InteractionMode;
(function (InteractionMode) {
    InteractionMode["DoubleClickItemToExpand"] = "double-click-item-to-expand";
    InteractionMode["ClickItemToExpand"] = "click-item-to-expand";
    InteractionMode["ClickArrowToExpand"] = "click-arrow-to-expand";
})(InteractionMode || (InteractionMode = {}));
